import { jsx } from 'react/jsx-runtime';
import { styled, alpha, Typography } from '@mui/material';
import { CommonWrapper } from './CommonWrapper.js';

function BreadcrumbsLink({ children, "data-testid": dataTestId, sxWrapper, }) {
    return (jsx(CommonWrapper, { sx: sxWrapper, children: jsx(LinkWrapper, { "data-testid": dataTestId, children: jsx(Typography, { fontSize: 12, fontWeight: 500, sx: { paddingLeft: 0, textTransform: "uppercase" }, children: children }) }) }));
}
const LinkWrapper = styled("span")(({ theme }) => ({
    borderRadius: 4,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 1,
    padding: theme.spacing(0.5),
    textTransform: "uppercase",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
        textDecorationLine: "none",
        backgroundColor: theme.palette.primary[50],
    },
    "&:active": {
        backgroundColor: alpha(theme.palette.primary.main, 0.15),
    },
}));

export { BreadcrumbsLink, LinkWrapper };
//# sourceMappingURL=BreadcrumbsLink.js.map
